import Barcode from './src/barcode-combined';
export default Barcode;